import View from './view';
export const ProfileWidget = View;
